var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnverifiedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px/not_verified_300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99493 12.6799C10.1608 12.6799 10.3013 12.6238 10.4164 12.5116C10.5315 12.3995 10.5891 12.2604 10.5891 12.0946C10.5891 11.9287 10.533 11.7883 10.4208 11.6731C10.3086 11.558 10.1696 11.5005 10.0037 11.5005C9.83786 11.5005 9.69738 11.5566 9.58227 11.6688C9.46715 11.781 9.4096 11.92 9.4096 12.0858C9.4096 12.2517 9.4657 12.3921 9.57789 12.5073C9.69007 12.6224 9.82909 12.6799 9.99493 12.6799ZM9.45768 10.1768H10.541V6.32101H9.45768V10.1768ZM9.99933 17.5677C8.25254 17.1041 6.80195 16.0894 5.64758 14.5238C4.4932 12.9581 3.91602 11.2073 3.91602 9.2713V4.78895L9.99933 2.44922L16.0826 4.78895V9.2713C16.0826 11.2073 15.5055 12.9581 14.3511 14.5238C13.1967 16.0894 11.7461 17.1041 9.99933 17.5677ZM9.99933 16.438C11.4438 15.9901 12.6382 15.0942 13.5827 13.7505C14.5271 12.4067 14.9993 10.9137 14.9993 9.2713V5.5213L9.99933 3.61266L4.99933 5.5213V9.2713C4.99933 10.9137 5.47155 12.4067 6.41599 13.7505C7.36044 15.0942 8.55488 15.9901 9.99933 16.438Z",
    fill: "#EE8A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedDark);
export default __webpack_public_path__ + "static/media/unverifiedDark.cf5b73132ee2b079987e909dade9fb41.svg";
export { ForwardRef as ReactComponent };